import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import $ from 'jquery';
import { useCart } from '../CartContext';
import { supabase } from '../lib/supabaseClient.ts';
import AdvancedSearch from './search/AdvancedSearch.js';

const categories = [
  {
    name: "Alimentation",
    image: "img/icons/alimentation.jpg",
    subcategories: ["Croquettes", "Boîtes & Pochon & Barquette", "Friandises", "Compléments alimentaires"]
  },
  {
    name: "Hygiène et soins",
    image: "img/icons/higiene.jpeg",
    subcategories: ["Produits antiparasitaires", "Produits d'hygiène", "Matériel toilettage"]
  },
  {
    name: "Cage et Sacs de transports",
    image: "img/icons/sac.jpg",
  },
  {
    name: "Gamelles et distributeur",
    image: "img/icons/gamelle.jpg",
  },
  {
    name: "Arbre à chat et griffoirs",
    image: "img/icons/arbre.jpg",
  },
  {
    name: "Jouets",
    image: "img/icons/jouets.jpeg",
  },
  {
    name: "Litière",
    image: "img/icons/lait.jpg",
    subcategories: ["Abosorbante", "Agglomérante", "Bac et Maison de toilette"]
  },
  {
    name: "Sellerie",
    image: "img/icons/Sellerie.jpg",
    emptyMessage: "Aucun produit ne correspond à votre sélection 🐾"
  }
];

const dogcategories = [
  {
    name: "Alimentation",
    image: "img/icons/alm.jpg",
    subcategories: ["Croquettes", "Boîtes & Pochon & Barquette", "Friandises", "Compléments alimentaires"]
  },
  {
    name: "Hygiène et soins",
    image: "img/icons/hyg.jpeg",
    subcategories: ["Produits antiparasitaires", "Produits d'hygiène", "Matériel toilettage"]
  },
  { name: "Couchages", image: "img/icons/couche.jpg" },
  { name: "Gamelles et accessoires", image: "img/icons/gamellee.png" },
  { name: "Jouets", image: "img/icons/jou.jpg" },
  { name: "Niches et cages", image: "img/icons/nichee.jpg" },
  {
    name: "Sellerie",
    image: "img/icons/sell.jpg",
    emptyMessage: "Aucun produit ne correspond à votre sélection 🐾"
  }
];

function Header() {
  const { cart, removeFromCart ,updateQuantity} = useCart();
  const [mobileCartOpen, setMobileCartOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [rodentCategories, setRodentCategories] = useState([]);
  const [birdCategories, setBirdCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [dogcategories, setDogCategories] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const navigate = useNavigate();

const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);

const handleSearchToggle = () => {
  setAdvancedSearchOpen(!advancedSearchOpen);
  setBurgerMenuOpen(false);
  setMobileCartOpen(false);
};
useEffect(() => {
  if (advancedSearchOpen) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }
  
  return () => {
    document.body.classList.remove('modal-open');
  };
}, [advancedSearchOpen]);
const handleBurgerMenuToggle = () => {
  setBurgerMenuOpen(!burgerMenuOpen);
  setSearchOpen(false);  // Close the search when burger menu is toggled
  setMobileCartOpen(false);  // Close the cart when burger menu is toggled
};

const handleCartToggle = () => {
  setMobileCartOpen(!mobileCartOpen);
  setSearchOpen(false);  // Close the search when cart is toggled
  setBurgerMenuOpen(false);  // Close the burger menu when cart is toggled
};

  const handleSearchChange = async (e) => {
    const q = e.target.value;
    setSearchQuery(q);
    if (q.trim().length > 1) {
      const { data, error } = await supabase
        .from("products")
        .select("id, name, image") //  include the image field
        .ilike("name", `%${q}%`)
        .limit(5);


      if (!error) setFilteredProducts(data);
    } else {
      setFilteredProducts([]);
    }
  };

  const handleSelectProduct = (id) => {
    setSearchQuery("");
    setFilteredProducts([]);
    setSearchOpen(false);
    navigate(`/shop-details/${id}`);
  };
  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "cat");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        // Desired order
        const order = ["Aliments Pour Chats", "Accessoires Pour Chats"];
        const sortedData = [...data].sort((a, b) => {
          const indexA = order.indexOf(a.name);
          const indexB = order.indexOf(b.name);

          // If a category is not in order array, push it to the end
          const posA = indexA === -1 ? Number.MAX_VALUE : indexA;
          const posB = indexB === -1 ? Number.MAX_VALUE : indexB;

          return posA - posB;
        });

        setCategories(sortedData);
        if (sortedData.length > 0) {
          setSelectedCategory(sortedData[0].name); // Default category
        }
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchDogCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "dog");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        // Ordre souhaité
        const order = ["Aliments Pour Chiens", "Accessoires Pour Chiens"];
        const sortedData = [...data].sort((a, b) => {
          const indexA = order.indexOf(a.name);
          const indexB = order.indexOf(b.name);

          // Les catégories non listées vont à la fin
          const posA = indexA === -1 ? Number.MAX_VALUE : indexA;
          const posB = indexB === -1 ? Number.MAX_VALUE : indexB;

          return posA - posB;
        });

        setDogCategories(sortedData);
        if (sortedData.length > 0) {
          setSelectedCategory(sortedData[0].name); // catégorie par défaut
        }
      }
    };

    fetchDogCategories(); // appel de la fonction asynchrone
  }, []);

  // 🐭 Fetch Rodent categories
  useEffect(() => {
    const fetchRodentCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "rongeur");

      if (error) {
        console.error("Error fetching rodent categories:", error);
      } else {
        setRodentCategories(data);
      }
    };

    fetchRodentCategories();
  }, []);

  // 🐦 Fetch Bird categories
  useEffect(() => {
    const fetchBirdCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "oiseaux");

      if (error) {
        console.error("Error fetching bird categories:", error);
      } else {
        setBirdCategories(data);
      }
    };

    fetchBirdCategories();
  }, []);
  function parsePrice(priceStr) {
    if (!priceStr) return 0;
    return parseFloat(priceStr.replace(",", ".").replace(/[^\d.]/g, "")) || 0;
  }
  const getItemPrice = (item) => {
  // If the item has a selected variation with an oldPrice, use it; otherwise use selectedPrice
  if (item.selectedWeight || item.selectedGout) {
    return Number(item.oldPrice || item.selectedPrice || 0);
  }
  return Number(item.selectedPrice || 0);
};

  // Format price for display
const formatPrice = (price) => {
  if (price == null) return "0.000";
  return new Intl.NumberFormat('fr-FR', { 
    minimumFractionDigits: 3, 
    maximumFractionDigits: 3 
  }).format(Number(price));
};


  // Calculate total
  const total = cart.reduce((sum, item) => {
    const price = Number(item.selectedPrice) || 0;
    const qty = Number(item.quantity) || 1;
    return sum + price * qty;
  }, 0);

  const totalFormatted = formatPrice(total);

  // const totalFormatted = total.toFixed(2);

const renderVariation = (item) => {
  if (!item.selectedGout && !item.selectedWeight) return null;

  return (
    <div
      style={{
        fontSize: "12px",
        color: "#777",
        marginTop: "2px",
        marginBottom: "4px",
      }}
    >
      {item.selectedGout && <span>Goût : {item.selectedGout}</span>}
      {item.selectedGout && item.selectedWeight && <span> • </span>}
      {item.selectedWeight && <span>Poids : {item.selectedWeight}</span>}
    </div>
  );
};


  const handleActive = (e) => {
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    });
    e.target.parentNode.classList += ' active';
  };

  const subActive = (e) => {
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    });
    e.target.parentNode.parentNode.parentNode.classList += ' active';
  };

  useEffect(() => {
    // SubMenu Dropdown Toggle
    if ($('.menu-area li.menu-item-has-children ul').length) {
      $('.menu-area .navigation li.menu-item-has-children').append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');
    }

    if ($('.mobile-menu').length) {
      var mobileMenuContent = $('.menu-area .main-menu').html();
      $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);

      // Dropdown Button
      $('.mobile-menu li.menu-item-has-children .dropdown-btn').on('click', function () {
        $(this).toggleClass('open');
        $(this).prev('ul').slideToggle(500);
      });

      // Menu Toggle Btn
      $('.mobile-nav-toggler').on('click', function () {
        $('body').addClass('mobile-menu-visible');
      });

      // Close mobile menu on backdrop or close button
      $('.menu-backdrop, .mobile-menu .close-btn').on('click', function () {
        $('body').removeClass('mobile-menu-visible');
      });

      // ✅ Close mobile menu after choosing an item
      $('.mobile-menu .menu-box .menu-outer a').on('click', function () {
        $('body').removeClass('mobile-menu-visible');
      });
    }

    $(".navbar-toggle").on('click', function () {
      $(".navbar-nav").addClass("mobile_menu");
    });

    $(".navbar-nav li a").on('click', function () {
      $(".navbar-collapse").removeClass("show");
    });

    $(".header-search > a").on('click', function () {
      $(".search-popup-wrap").slideToggle();
      return false;
    });

    $(".search-close").on('click', function () {
      $(".search-popup-wrap").slideUp(500);
    });
  }, []);


  return (
    <header>
      <div className="header-top-area">
        <div className="container custom-container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <div className="header-top-left">
                <ul>
                  <li>Appelez-nous:+216 90 117 027</li>
                  <li><i className="far fa-clock" />Horaire: 09:00 - 20:00 / 7j/7</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="header-top-right">
                <ul className="header-top-social">
                  <li className="follow">Follow :</li>
                  <li>
                    <a
                      href="https://www.facebook.com/animaliamutu/?locale=fr_FR"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/animaliaplus/?hl=fr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div id="sticky-header" className="menu-area">
        <div className="container custom-container">

          <div className="row">
            <div className="col-12">

<div className="burger-search-wrap" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  {/* Burger button */}
   {window.innerWidth < 768 && (
  <div 
    className="mobile-nav-toggler" 
    style={{ position: "absolute", top: "10px", left: "240px" }} 
    onClick={(e) => {
      e.stopPropagation(); 
      handleBurgerMenuToggle();
    }}
  >
    <img src="/img/icon/burger.png" alt="Menu" style={{ width: '24px', height: '18px' }} />
  </div>
 )}
  {/* Mobile Cart Icon */}
  {window.innerWidth < 768 && (
    <div
      className="mobile-cart-icon"
      style={{ position: "relative", marginRight: "10px", cursor: "pointer", marginTop: "20px" }}
      onClick={(e) => {
        e.stopPropagation(); // Prevent event bubbling
        handleCartToggle();
      }}
    >
      <i className="flaticon-shopping-bag" style={{ fontSize: "20px", color: "#ff41b4" }} />

      {/* Badge for number of items */}
      {cart.length > 0 && (
        <span style={{
          position: "absolute",
          top: "-6px",
          right: "-6px",
          background: "#ff41b4",
          color: "#fff",
          fontSize: "12px",
          fontWeight: "bold",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 0 4px rgba(0,0,0,0.2)",
        }}>
          {cart.length}
        </span>
      )}
    </div>
  )}

  {/* Search icon - mobile only - FIXED VERSION */}
  {window.innerWidth < 768 && (
    <div
      className="mobile-search-icon"
      onClick={(e) => {
        e.stopPropagation(); // Prevent event bubbling
        handleSearchToggle(); // This will open advanced search
      }}
      style={{ 
        cursor: 'pointer', 
        marginTop: '20px',
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10 // Ensure it's clickable
      }}
    >
 <i
  className="fas fa-search"
  style={{
    color: "#ff41b4",
    fontSize: "18px",
    position: "relative",
    top: "-5px", // increase value to move more up
  }}
/>

    </div>
  )}
</div>

              {/* Mobile Cart dropdown */}
              {mobileCartOpen && (
                <div
                  className="mobile-cart-dropdown"
                  style={{
                    position: 'absolute',
                    top: '50px',
                    right: '10px', // align properly
                    width: window.innerWidth < 768 ? '90%' : '250px', // fit mobile
                    maxWidth: '350px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    background: '#fff',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '10px',
                    zIndex: 1000,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  }}
                >
                  {cart.length === 0 ? (
                    <div className="text-center p-3">Votre panier est vide 🛒</div>
                  ) : (
cart.map((item) => (
  <div
    key={item.id}
    className="d-flex align-items-start mb-2"
    style={{ cursor: "pointer" }}
    onClick={() => {
      // Hide mobile cart
      setMobileCartOpen(false);

      // Navigate to product details
      navigate(`/shop-details/${item.id}`);

      // Scroll down by 30px
      window.scrollBy({ top: 30, left: 0, behavior: "smooth" });
    }}
  >
    {/* Image */}
    <img
      src={item.image}
      alt={item.name}
      style={{
        width: window.innerWidth < 768 ? "60px" : "50px",
        height: window.innerWidth < 768 ? "60px" : "50px",
        objectFit: "cover",
        borderRadius: "4px",
        flexShrink: 0,
        transform: "translateX(10px)",
      }}
    />

    {/* Content */}
    <div style={{ flex: 1, marginLeft: "10px" }}>
      <div>{item.name}</div>
        {renderVariation(item)}

      <div style={{ fontWeight: "bold" }}>
  {new Intl.NumberFormat("fr-FR").format(item.selectedPrice)} DT × {item.quantity}
      </div>
    </div>

    {/* Remove Button */}
    <button
      onClick={(e) => {
        e.stopPropagation(); // Prevent triggering parent click
        removeFromCart(item.id);
      }}
      style={{
        background: "none",
        border: "none",
        color: "#c00",
        cursor: "pointer",
      }}
    >
      <i className="far fa-trash-alt" />
    </button>
  </div>
))


                  )}

                    {/* TOTAL + BUTTONS */}
    {cart.length > 0 && (
      <>
        <div
          style={{
            fontWeight: "700",
            fontSize: "16px",
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 2px",
            borderTop: "1px solid #eee",
          }}
        >
          <span>Total :</span>
          <span>
          {new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format(
  cart.reduce((acc, item) => acc + item.selectedPrice * item.quantity, 0)
)}{" "}
DT

          </span>
        </div>

        <div
          className="cart-buttons"
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          {/* PANIER */}
          <Link
            to="/cart"
            onClick={() => setMobileCartOpen(false)}
            style={{
              flex: 1,
              padding: "10px 16px",
              backgroundColor: "#ff41b4",
              color: "#fff",
              borderRadius: "30px",
              textDecoration: "none",
              fontWeight: "600",
              textAlign: "center",
              transition: "0.25s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e03299")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#ff41b4")
            }
          >
            Panier
          </Link>

          {/* PAIEMENT */}
          <Link
            to="/checkout"
            onClick={() => setMobileCartOpen(false)}
            style={{
              flex: 1,
              padding: "10px 16px",
              backgroundColor: "#ff41b4",
              color: "#fff",
              borderRadius: "30px",
              textDecoration: "none",
              fontWeight: "600",
              textAlign: "center",
              transition: "0.25s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e03299")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#ff41b4")
            }
          >
            Paiement
          </Link>
        </div>
      </>
    )}
                </div>
              )}



              <Link to="/" style={{ display: "inline-block" }}>

                <div className="menu-wrap">
                  <nav className="menu-nav show">
                    <div className="logo" style={{ display: "inline-block" }}>
                      <img
                        src="img/logo/animalia.png"
                        alt="Animalia Logo"
                        title="Animalia"
                        style={{
                          width: window.innerWidth > 768 ? "350px" : "300px",
                          height: "auto",
                          marginLeft: window.innerWidth > 768 ? "-160px" : "-80px", // web: -160px, mobile: 0
                        }}
                      />
                    </div>


                    <div
                      className="navbar-wrap main-menu d-none d-lg-flex justify-end pr-2 ms-0 "
                      style={{ minWidth: "920px" }} // or any suitable width like "900px"
                    >                    <ul className="navigation flex  text-xs items-center ">
                        <li className="active menu-item-has-children">
                          <Link to="/">Acceuil</Link>
                        </li>

                        <li className="has-submenu">
                          <Link to="/catlist" onClick={handleActive}>Chats</Link>
                          <ul className="submenu">
                            {categories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`} onClick={subActive}>{cat.name}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>

                        <li className="has-submenu">
                          <Link to="/doglist" onClick={handleActive}>Chiens</Link>
                          <ul className="submenu">
                            {dogcategories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`} onClick={subActive}>{cat.name}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                        {/* Rongeurs */}
                        <li className="has-submenu">
                          <Link to="/rongeurlist">Rongeurs</Link>
                          <ul className="submenu">
                            {rodentCategories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`}>
                                  {cat.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>

                        {/* Oiseaux */}
                        <li className="has-submenu">
                          <Link to="/birdlist">Oiseaux</Link>
                          <ul className="submenu">
                            {birdCategories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`}>
                                  {cat.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="menu-item-has-children">
                          <Link to="/shop" onClick={handleActive}>Shop</Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link to="/categories" onClick={handleActive}>Catégories</Link>
                        </li>

                        <li className="menu-item-has-children">
                          <Link to="/bons" onClick={handleActive}>Bon plan</Link>
                        </li>
                        <li>
                          <Link to="/contacts" onClick={handleActive}>Contact</Link>
                        </li>
                      </ul>
                    </div>



                    {/* Desktop Cart */}
                    <div className="header-action d-none d-md-block">
                      <ul>
                        {/* <li className="header-search">
                        <a href="/#"><i className="flaticon-search" /></a>
                      </li> */}
                      

                        <li className="header-shop-cart">
                          <a
                            href="/#"
                            className="cart-icon-wrapper"
                            style={{ position: "relative", display: "inline-block" }}
                          >
                            <i className="flaticon-shopping-bag" style={{ fontSize: "20px", marginLeft: "40px" }} />
                            {cart.length > 0 && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  left: "50px",
                                  background: "#ff41b4",
                                  color: "#fff",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  borderRadius: "50%",
                                  width: "18px",
                                  height: "18px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                }}
                              >
                                {cart.length}
                              </span>
                            )}
                          </a>


<ul
  className="minicart"
  style={{
    width: "420px",   // control minicart width here
    maxHeight: "70vh",
    overflowY: "auto",
    padding: "12px",
  }}
>
{cart.map((item, index) => {
  const price = Number(item.selectedPrice) || 0;
  const qty = Number(item.quantity) || 1;

  return (
    <li
      key={item.id}
      className="d-flex align-items-center"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 0",
        borderBottom: "1px solid #eee",
        marginLeft: index === 0 ? "10px" : "0", // 👈 Add margin only for first item
      }}
                onClick={() => navigate(`/shop-details/${item.id}`)} // navigate on click

    >
         
        {/* Product Image */}
        <div
          className="cart-img"
          style={{ flexShrink: 0, marginRight: "-5px" ,width:"400px"}}
        >
          <Link to={`/shop-details/${item.id}`}>
            <img
              src={item.image}
              alt={item.name}
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />
          </Link>
        </div>

        {/* Product Content */}
{/* Product Content */}
<div
  className="cart-content"
  style={{
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  }}
>
  <h4 style={{ margin: "0 0 4px 0", fontSize: "14px" }}>
    <Link to={`/shop-details/${item.id}`}>{item.name}</Link>
    {renderVariation(item)}
  </h4>
<div
  className="cart-price d-flex align-items-center"
  style={{ fontSize: "13px", marginBottom: "6px" }}
>
<span className="new">
    {getItemPrice(item).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} DT x {item.quantity}
</span>
  <span
    className="total-price"
    style={{ fontWeight: "bold", marginLeft: "10px", marginTop: "-20px" }}
  >
    = {(getItemPrice(item) * item.quantity).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} DT
  </span>
</div>


  {/* Quantity Controls */}
  <div className="d-flex align-items-center">
    <button
      onClick={() => updateQuantity(item.id, item.quantity - 1)}
      disabled={item.quantity <= 1}
      style={{
        width: "26px",
        height: "26px",
        borderRadius: "50%",
        border: "none",
        background: "#ff41b4",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "14px",
        cursor: item.quantity <= 1 ? "not-allowed" : "pointer",
        opacity: item.quantity <= 1 ? 0.5 : 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      -
    </button>
    <span
      style={{
        minWidth: "25px",
        textAlign: "center",
        margin: "0 6px",
        color: "gray",
      }}
    >
      {item.quantity}
    </span>
    <button
      onClick={() => updateQuantity(item.id, item.quantity + 1)}
      style={{
        width: "26px",
        height: "26px",
        borderRadius: "50%",
        border: "none",
        background: "#ff41b4",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "14px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      +
    </button>
  </div>
</div>

        {/* Delete Button */}
        <div
          className="del-icon"
          style={{
            flexShrink: 0,
            marginLeft: "10px",
          }}
        >
          <button
            onClick={() => removeFromCart(item.id)}
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              border: "none",
              background: "#ffe5eb",
              color: "#c00",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }} />
          </button>
        </div>
      </li>
    );
  })}

  {cart.length > 0 ? (
    <>
      <li>
        <div className="total-price" style={{ fontWeight: "bold",color:"gray" }}>
          Total: {totalFormatted} DT
        </div>
      </li>
      <li>
        <div className="checkout-link d-flex justify-content-between">
          <Link to="/cart">Panier</Link>
          <Link to="/checkout" className="black-color">
            Paiement
          </Link>
        </div>
      </li>
    </>
  ) : (
    <li className="text-center p-3">Votre panier est vide 🛒</li>
  )}
</ul>


                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </Link>

              {/* Mobile Menu */}
              <div className="mobile-menu">

                <nav className="menu-box" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                  <div className="close-btn"><i className="fas fa-times" /></div>
                  <div className="nav-logo">
                    <Link to="/"><img src="img/logo/animalia.png" alt="" title='true' /></Link>
                  </div>
                  <div className="menu-outer"></div>
                  {/* MOBILE CART */}
                  <div className="mobile-shop-cart mt-4 px-3 ">
                    <a href="/#" onClick={(e) => {
                      e.preventDefault();
                      setMobileCartOpen(!mobileCartOpen);
                    }} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      cursor: 'pointer',
                      color: '#000',
                      fontWeight: '600',
                      fontSize: '16px',
                    }}>
                      <i className="flaticon-shopping-bag" />
                      <span>{cart.length}</span>
                      <span>Panier</span>
                      <i className={`fas fa-chevron-${mobileCartOpen ? 'up' : 'down'}`} style={{ marginLeft: 'auto' }} />
                    </a>

                    {mobileCartOpen && (
                      <ul
                        className="minicart"
                        style={{
                          top: '80px', // 👈 move dropdown down
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          borderRadius: '6px',
                          padding: '10px',
                          background: '#fff',
                          position: 'absolute', // make sure it's absolute relative to the cart icon
                          right: '0', // align to right of the cart icon
                          zIndex: 1000,
                          maxHeight: '300px',
                          overflowY: 'auto',
                        }}
                      >
                        {cart.length === 0 ? (
                          <li className="text-center p-3">Votre panier est vide 🛒</li>
                        ) : (
                          cart.map((item) => {
                            const price = Number(item.selectedPrice) || 0;
                            const qty = Number(item.quantity) || 1;
                            return (
                              <li className="d-flex align-items-start" key={item.id}>
                                <div className="cart-img">
                                  <Link to={`/shop-details/${item.id}`}>
                                    <img src={item.image} alt={item.name} />
                                  </Link>
                                </div>
                                <div className="cart-content">
                                  <h4>
                                    <Link to={`/shop-details/${item.id}`}>{item.name}</Link>
                                  </h4>
                                  <div className="cart-price">
                                    <span className="new">
                                      {formatPrice(price)} DT x {qty}
                                    </span>
                                    <span className="total-price" style={{ fontWeight: 'bold', marginLeft: '10px' }}>
                                      = {formatPrice(price * qty)} DT
                                    </span>
                                  </div>
                                </div>
                                <div className="del-icon">
                                  <button
                                    onClick={() => removeFromCart(item.id)}
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'pointer',
                                      color: '#c00',
                                      marginLeft: '-10px',
                                    }}
                                  >
                                    <i className="far fa-trash-alt" />
                                  </button>
                                </div>
                              </li>
                            );
                          })
                        )}

                        {cart.length > 0 && (
                          <>
                            <li>
                              <div className="total-price">
                                <span className="f-left"></span>
                                <span>Total: {totalFormatted} DT</span>
                              </div>
                            </li>
                            <li>
                              <div className="checkout-link">
                                <Link to="/cart">Panier</Link>
                                <Link to="/checkout" className="black-color">Paiement</Link>
                              </div>
                            </li>
                          </>
                        )}
                      </ul>

                    )}
                  </div>
                  {/* Mobile Social Links */}
                  <div className="social-links">
                    Follow:
                    <ul className="clearfix">
                      {/* <li><a href="/#"><span className="fab fa-twitter" /></a></li> */}
                      <li><a href="/#"><span className="fab fa-facebook-square" /></a></li>
                      {/* <li><a href="/#"><span className="fab fa-pinterest-p" /></a></li> */}
                      <li><a href="/#"><span className="fab fa-instagram" /></a></li>
                      {/* <li><a href="/#"><span className="fab fa-youtube" /></a></li> */}
                    </ul>
                  </div>



                </nav>
              </div>

              <div className="menu-backdrop" />
            </div>
            {/* Search Icon/Button - Opens Advanced Search */}
{window.innerWidth >= 992 && (
  <div
    onClick={handleSearchToggle}
    style={{
      position: 'relative',
      marginTop: '20px',       // espace au-dessus
      marginBottom: '20px',    // espace sous le bouton
      marginLeft: 'auto',      // centre horizontalement
      marginRight: 'auto',     // centre horizontalement
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center', // texte centré dans le bouton
      gap: '10px',
      width: '900px',          // largeur fixe
      padding: '10px 20px',    // padding vertical et horizontal
      border: '2px solid #ff41b4',
      borderRadius: '25px',
      background: 'white',
      transition: 'all 0.3s ease',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = '#fff5fb';
      e.currentTarget.style.transform = 'scale(1.02)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = 'white';
      e.currentTarget.style.transform = 'scale(1)';
    }}
  >
    <i className="fas fa-search" style={{ color: '#ff41b4', fontSize: '16px' ,marginLeft:'40px'}} />
    <span style={{ color: '#ff41b4', fontWeight: '600', fontSize: '14px' }}>
    </span>
Chercher un article ...  </div>
)}




          </div>
        </div>
        {/* <div className="header-shape" style={{ backgroundImage: "url('img/bg/header_shape.png')" }} /> */}
      </div>

      <div className="search-popup-wrap" tabIndex={-1} role="dialog" aria-hidden="true">
        <div className="search-close">
          <span><i className="fas fa-times" /></span>
        </div>
        <div className="search-wrap text-center">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="title">... Search Here ...</h2>
                <div className="search-form">
                  <form>
                    <input type="text" name="search" placeholder="Type keywords here" />
                    <button className="search-btn"><i className="fas fa-search" /></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <AdvancedSearch 
      isOpen={advancedSearchOpen} 
      onClose={() => setAdvancedSearchOpen(false)} 
    />
    </header>
  );
}

export default Header;
